<template>
  <div v-if="!isPrint">
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :visible-field-form="false"
      :board="this.board"
      :is-print="isPrint"
    />

    <div class="writeGridContainer mt-4">
      <div class="writeGridCol2">
        <div>시설명</div>
        <p v-if="isPrint" class="print-input">{{ fieldNames }}</p>
        <field-selector v-else v-model="form.시설명" multiple/>
      </div>
      <div class="writeGridCol2">
        <div>소관부서</div>
        <span class="print-input"> {{소관부서}} </span>
      </div>
      <div />

      <div>
        <div>관리방법</div>
        <p v-if="isPrint" class="print-input">{{ form.관리방법 }}</p>
        <vs-select v-else class="w-full flex-1" autocomplete v-model="form.관리방법" >
          <vs-select-item v-for="option in ['직접관리', '위탁관리']" :key="`select1_${option}`" :text="option" :value="option" />
        </vs-select>
      </div>
<!--      <div>-->
<!--        <div>소관부서</div>-->
<!--        <p v-if="isPrint" class="print-input">{{ form.소관부서 }}</p>-->
<!--        <ml-input v-else v-model="form.소관부서" class="w-full" />-->
<!--      </div>-->
    </div>

    <!-- 머리글 -->
    <div>
      <vs-row class="mt-6">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 머리글</h5>
        </vs-col>
      </vs-row>

      <div class="mt-4">
        <p v-if="isPrint" class="print-textarea" v-html="form.머리글" />
        <ml-textarea v-else @input="(value) => inputTextArea('머리글', value)" class="w-full"
                     :value="form.머리글.replace(/<br\/>/g, '\n')"/>
        <p class="mt-1">* 시설물안전법에 의한 작성대상 시설물은 안전 및 유지관리계획으로 작성 가능함</p>
      </div>
    </div>

    <!-- 1. 관련근거 -->
    <div class="mt-8">
      <div class="eTitle">1. 관련근거</div>
      <div class="mt-4">
        <p v-if="isPrint" class="print-textarea" v-html="form.관련근거" />
        <quill-editor class="vx-col flex-1 ql-edit-text" v-model="form.관련근거"></quill-editor>
      </div>
    </div>

    <!-- 2. 현황(시설물, 예산 등) -->
    <div class="mt-8">
      <div class="eTitle">2. 현황(시설물, 예산 등)</div>
      <!-- 1. 시설물 및  안전사고 ... -->
      <div class="mt-4 gap-2 flex">
        <h5><i class="dot"></i> 1. 시설물 및 안전사고 발생 현황</h5>
        <span style="color: #4839EB">※시설물 특성에 따라 작성, 서식변경 가능</span>
      </div>
      <div class="writeGridContainer mt-4">
        <div class="writeGridLineItem">
          <div style="line-height: normal;">안전관리 대상 시설 현황</div>
          <p v-if="isPrint" class="print-textarea" v-html="form.안전관리대상시설현황" />
          <ml-textarea v-else @input="(value) => inputTextArea('안전관리대상시설현황', value)" class="w-full"
                      :value="form.안전관리대상시설현황.replace(/<br\/>/g, '\n')" />
        </div>
      </div>

      <table-custom
        :board="board"
        :is-print="isPrint"
        title="< 안전관리 대상 시설 현황 >"
        titleType="small"
        :tableData="[
        { id: '관리주체', title: '관리주체', type: 'text', placeholder: '○○랜드', style: { textAlign: 'left' }  },
        { id: '구분유형', title: '구분유형', type: 'text', placeholder: '생활여가시설', style: { textAlign: 'left' }  },
        { id: '사용용도', title: '사용용도', type: 'text', placeholder: '공영주차장 등', style: { textAlign: 'left' }  },
        { id: '구조', title: '구조, 층수', type: 'text', placeholder: '다중이용시설(주차장)', style: { textAlign: 'left' }  },
        { id: '연면적', title: '연면적(㎡)', type: 'text', placeholder: '000', style: { textAlign: 'left' }  },
        { id: '비고', title: '비고', type: 'text', placeholder: '유', style: { textAlign: 'left' }  },
      ]"
        v-model="form.안전관리대상시설현황리스트"
      />

      <div class="writeGridContainer mt-4">
        <div class="writeGridLineItem">
          <div style="line-height: normal;">안전사고 발생현황</div>
          <p v-if="isPrint" class="print-textarea" v-html="form.안전사고발생현황" />
          <ml-textarea v-else @input="(value) => inputTextArea('안전사고발생현황', value)" class="w-full"
                       :value="form.안전사고발생현황.replace(/<br\/>/g, '\n')" />
        </div>
      </div>

      <div class="mt-8 flex justify-between">
        <div class="flex gap-2 items-center">
          <span class="sTitle">< 연도별 안전사고 발생현황 ></span>
          <p v-if="isPrint" class="print-input">{{ form.안전사고발생년도 }}</p>
          <vs-select v-else class="w-full flex-1" style="max-width: 120px;" autocomplete v-model="form.안전사고발생년도" >
            <vs-select-item v-for="option in years" :key="`select2_${option}`" :text="option" :value="option" />
          </vs-select>
          <span>~</span>
          <p class="print-input" style="width: 120px;">{{ form.안전사고발생년도 + 2 }}</p>
        </div>
        <span style="font-weight: 400;">(단위 : 건, 명) ※ 괄호 부분은 직원사고</span>
      </div>
      <table class="mt-2">
        <colgroup>
          <col style="width: 220px" />
          <col style="width: 220px" />
          <col />
          <col />
          <col />
          <col />
        </colgroup>
        <thead>
        <tr>
          <th colspan="2">구분</th>
          <th>평균</th>
          <th>{{ form.안전사고발생년도 }}</th>
          <th>{{ form.안전사고발생년도 + 1 }}</th>
          <th>{{ form.안전사고발생년도 + 2 }}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, itemIndex) in form.안전사고발생현황리스트" :key="`안전사고발생현황리스트_${itemIndex}`">
          <th v-if="itemIndex === 0" rowspan="3">인명피해</th>
          <th>{{ item.구분 }}</th>
          <td>{{ (item.년도별.reduce((sum, value) => sum + Number(value), 0) / item.년도별.length).toFixed(2) }}</td>
          <td v-for="(year, yearIndex) in item.년도별" :key="`year_${yearIndex}`">
            <p v-if="isPrint" class="print-input">{{ year }}</p>
            <ml-input v-else v-model="form.안전사고발생현황리스트[itemIndex].년도별[yearIndex]" class="w-full" style="text-align: start;"/>
          </td>
        </tr>
        </tbody>
      </table>

      <div class="writeGridContainer mt-4">
        <div class="writeGridLineItem">
          <div style="line-height: normal;">안전등급 및 점검결과</div>
          <p v-if="isPrint" class="print-textarea" v-html="form.안전등급및점검결과" />
          <ml-textarea v-else @input="(value) => inputTextArea('안전등급및점검결과', value)" class="w-full"
                       :value="form.안전등급및점검결과.replace(/<br\/>/g, '\n')" />
        </div>
      </div>

      <table-custom
        :board="board"
        :is-print="isPrint"
        :tableData="[
        { id: '구분', title: '구분', type: 'text', placeholder: '', style: { textAlign: 'left' }  },
        { id: '시설물분류', title: '시설물 분류', type: 'textarea', placeholder: '' },
        { id: '점검결과', title: '점검결과', type: 'textarea', placeholder: '' },
        { id: '조치결과', title: '조치결과', type: 'textarea', placeholder: '' },
      ]"
        v-model="form.안전등급및점검결과리스트"
      />

      <!-- 안전 예산현황 -->
      <div class="mt-4 gap-2">
        <h5><i class="dot"></i> 2. 안전 예산현황</h5>
        <div class="mt-1 flex justify-between">
          <span class="sTitle">❍ 안전계획이행, 시민재해 관리 업무 처리 이행, 안전보건관계 법령상 의무이행 비용 예산 등</span>
          <div class="flex gap-1">
            <span>(단위 : 천원)</span>
            <vs-checkbox v-model="form.is총예산입력">총예산으로 입력</vs-checkbox>
          </div>
        </div>
      </div>

      <table v-if="!form.is총예산입력" class="mt-2">
        <colgroup>
          <col style="width: 64px" />
          <col style="width: 200px" />
          <col />
          <col style="width: 300px" />
          <col style="width: 300px" />
        </colgroup>
        <thead>
        <tr>
          <th colspan="3">구분(포함항목)</th>
          <th>편성액</th>
          <th>비고</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td colspan="3">계</td>
          <td>
            <div class="flex gap-1 items-center">
              <span class="print-input">{{ 안전예산편성액_계 }}</span>
              <span class="whitespace-no-wrap">천원</span>
            </div>
          </td>
          <td>
            <p v-if="isPrint" class="print-input">{{ form.안전예산현황리스트_비고 }}</p>
            <ml-input v-else v-model="form.안전예산현황리스트_비고" class="w-full" style="text-align: start;"/>
          </td>
        </tr>
        <tr v-for="(item, itemIndex) in form.안전예산현황리스트" :key="`안전예산현황리스트_${itemIndex}`">
          <td v-if="itemIndex === 0" rowspan="5">안전예산</td>
          <td>{{ item.title }} </td>
          <td>{{ item.content }}</td>
          <td>
            <div class="flex gap-1 items-center">
              <p v-if="isPrint" class="print-input">{{ comma(item.편성액) }}</p>
              <number-input v-else v-model="form.안전예산현황리스트[itemIndex].편성액" class="w-full" />
              <span class="whitespace-no-wrap">천원</span>
            </div>
          </td>
          <td>
            <p v-if="isPrint" class="print-input">{{ item.비고 }}</p>
            <ml-input v-else v-model="form.안전예산현황리스트[itemIndex].비고" class="w-full" style="text-align: start;"/>
          </td>
        </tr>
        </tbody>
      </table>
      <table v-else class="mt-2">
        <colgroup>
          <col />
          <col style="width: 300px" />
          <col style="width: 300px" />
        </colgroup>
        <tr>
          <th>구분(포함항목)</th>
          <th>편성액</th>
          <th>비고</th>
        </tr>
        <tr>
          <td>총예산</td>
          <td>
            <div class="flex gap-1 items-center">
              <p v-if="isPrint" class="print-input">{{ comma(form.안전예산현황_총예산.편성액) }}</p>
              <number-input v-else v-model="form.안전예산현황_총예산.편성액" class="w-full" />
              <span class="whitespace-no-wrap">천원</span>
            </div>
          </td>
          <td>
            <p v-if="isPrint" class="print-input">{{ form.안전예산현황_총예산.비고 }}</p>
            <ml-input v-else v-model="form.안전예산현황_총예산.비고" class="w-full" style="text-align: start;"/>
          </td>
        </tr>
      </table>

      <!-- 3. 안전 인력 및 조직 현황 -->
      <div class="mt-8">
        <h5><i class="dot"></i> 3. 안전 인력 및 조직 현황</h5>
        <div class="mt-2 flex justify-between">
          <span class="sTitle">❍ 인력현황</span>
          <div class="flex gap-1">
            <vs-button color="secondary" @click="handleAddRowWorkForce"> 항목추가 </vs-button>
            <vs-button color="secondary" type="border" @click="handleRemoveRowWorkForce"> 선택삭제 </vs-button>
          </div>
        </div>
        <table class="mt-2">
          <colgroup>
            <col v-if="!isPrint" style="width: 50px" />
            <col />
            <col />
            <col style="width: 120px" />
            <col style="width: 120px" />
            <col style="width: 120px" />
            <col style="width: 120px" />
            <col style="width: 120px" />
            <col style="width: 120px" />
            <col />
          </colgroup>
          <thead>
          <tr>
            <th v-if="!isPrint" rowspan="3">
              <vs-checkbox :value="allCheckWorkForce" @change="handleSelectAllWorkForce" />
            </th>
            <th rowspan="3">구분</th>
            <th rowspan="3">해당업무</th>
            <th colspan="6">인력현황</th>
            <th rowspan="3">비고</th>
          </tr>
          <tr>
            <th>계</th>
            <th>공무원</th>
            <th>공무직</th>
            <th>기간제</th>
            <th>보건관리자</th>
            <th>기타</th>
          </tr>
          <tr>
            <td>
              <p class="print-input" style="background-color: #f9f9f9; text-align: end">{{ comma( form.인력현황리스트.reduce((sum, item) => sum + Number(item.계 || 0), 0) ) }}</p>
            </td>
            <td>
              <p class="print-input" style="background-color: #f9f9f9; text-align: end">{{ comma( form.인력현황리스트.reduce((sum, item) => sum + Number(item.공무원 || 0), 0) ) }}</p>
            </td>
            <td>
              <p class="print-input" style="background-color: #f9f9f9; text-align: end">{{ comma( form.인력현황리스트.reduce((sum, item) => sum + Number(item.공무직 || 0), 0) ) }}</p>
            </td>
            <td>
              <p class="print-input" style="background-color: #f9f9f9; text-align: end">{{ comma( form.인력현황리스트.reduce((sum, item) => sum + Number(item.기간제 || 0), 0) ) }}</p>
            </td>
            <td>
              <p class="print-input" style="background-color: #f9f9f9; text-align: end">{{ comma( form.인력현황리스트.reduce((sum, item) => sum + Number(item.보건관리자 || 0), 0) ) }}</p>
            </td>
            <td>
              <p class="print-input" style="background-color: #f9f9f9; text-align: end">{{ comma( form.인력현황리스트.reduce((sum, item) => sum + Number(item.기타 || 0), 0) ) }}</p>
            </td>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, itemIndex) in form.인력현황리스트" :key="`인력현황리스트_${itemIndex}`">
            <td v-if="!isPrint">
              <vs-checkbox v-model="item.isCheck" />
            </td>
            <td>
              <p v-if="isPrint" class="print-input">{{ item.구분 }}</p>
              <ml-input v-else v-model="item.구분" class="w-full" style="text-align: start"/>
            </td>
            <td>
              <p v-if="isPrint" class="print-textarea">{{ item.해당업무 }}</p>
              <ml-textarea v-else v-model="item.해당업무" class="w-full" />
            </td>
            <td>
              <p class="print-input" style="background-color: #f9f9f9; text-align: end">{{ comma( item.계 ) }}</p>
            </td>
            <td>
              <p v-if="isPrint" class="print-input">{{ comma(item.공무원) }}</p>
              <number-input v-else v-model="item.공무원" class="w-full" :min="0" @input="(value) => { input_인력현황(itemIndex) }"/>
            </td>
            <td>
              <p v-if="isPrint" class="print-input">{{ comma(item.공무직) }}</p>
              <number-input v-else v-model="item.공무직" class="w-full" :min="0" @input="(value) => { input_인력현황(itemIndex) }"/>
            </td>
            <td>
              <p v-if="isPrint" class="print-input">{{ comma(item.기간제) }}</p>
              <number-input v-else v-model="item.기간제" class="w-full" :min="0" @input="(value) => { input_인력현황(itemIndex) }"/>
            </td>
            <td>
              <p v-if="isPrint" class="print-input">{{ comma(item.보건관리자) }}</p>
              <number-input v-else v-model="item.보건관리자" class="w-full" :min="0" @input="(value) => { input_인력현황(itemIndex) }"/>
            </td>
            <td>
              <p v-if="isPrint" class="print-input">{{ comma(item.기타) }}</p>
              <number-input v-else v-model="item.기타" class="w-full" :min="0" @input="(value) => { input_인력현황(itemIndex) }"/>
            </td>
            <td>
              <p v-if="isPrint" class="print-input">{{ item.비고 }}</p>
              <ml-input v-else v-model="item.비고" class="w-full" style="text-align: start;"/>
            </td>
          </tr>
          </tbody>
        </table>
        <p class="sTitle mt-1">※ 안전조치 업무: 긴급안전조치, 공중이용시설 사용제한·사용금지·해체, 용도제한, 위험표지의 설치 등의 업무</p>
        <p class="sTitle">※ 중대재해법 의무사항 이행을 위한 필요인력, 개별법 등 에서 규정하는 인력을 포함하여 작성</p>

        <div class="flex gap-4 mt-4">
          <span class="sTitle">❍ 안전보건관리 조직도</span>
          <span>※ 필요시 작성, 안전인력에 대한 조직도</span>
        </div>
        <table class="mt-2">
          <tr>
            <th class="p-4">
              <p style="font-weight: 400; font-size: 14px; text-align: start;">
                ▶ 작성방법<br/>
                - 각 시설별 안전보건관리 책임자를 확인하여 작성<br/>
                - 시설 별 업무분장에 따라 수정하여 작성 가능<br/>
                - 위탁시설의 경우 수탁업체 현황 포함하여 작성 가능
              </p>

            </th>
          </tr>
        </table>

        <!-- 직영 위탁-->
        <table-organogram title="<직영>" class="mt-4" v-model="form.organogram1"></table-organogram>

        <table-organogram title="<위탁>" class="mt-4" v-model="form.organogram2"></table-organogram>
      </div>
    </div>

    <!-- 3. 세부추진 계획 -->
    <div class="mt-8">
      <div class="eTitle">3. 세부추진 계획</div>
      <!-- 1. 안전점검 계획 -->
      <div class="mt-4">
        <h5><i class="dot"></i> 1. 안전점검 계획</h5>
      </div>
      <div>
        <p class="my-4 sTitle">□ 근거 규정</p>
        <p v-if="isPrint" class="print-textarea" v-html="form.근거규정" />
        <ml-textarea v-else @input="(value) => inputTextArea('근거규정', value)" class="w-full"
                     :value="form.근거규정.replace(/<br\/>/g, '\n')" />
      </div>
      <table class="mt-2">
        <tr>
          <th class="p-4">
            <p style="font-weight: 400; font-size: 14px; text-align: start;">
              ▶ 작성방법<br/>
              - 시설물 안전법 포함 소관 시설물과 관련된 모든 관계법령에 대한 당해연도 점검계획수립<br/>
              - 위탁하여 관리하고 있는 분야가 있을 경우 위탁관리 점검 관리계획 작성<br/>
              ※ 아래사항은 세부추진계획 작성을 위한 형식, 대상 법령 등을 기재하였으므로 필요사항을 참고하여 작성조치
            </p>
          </th>
        </tr>
      </table>

      <table-custom
        class="mt-8"
        :board="board"
        :is-print="isPrint"
        title="점검 계획"
        thema="label"
        :tableData="[
        { id: '구분', title: '구분', type: 'text', placeholder: '', style: { textAlign: 'left' }  },
        { id: '세부구분', title: '세부구분', type: 'text', placeholder: '', style: { textAlign: 'left' }  },
        { id: '점검주기', title: '점검주기', type: 'text', placeholder: '', style: { textAlign: 'left' }  },
        { id: '내용', title: '내용', type: 'textarea', placeholder: '', style: { textAlign: 'left' }  },
        { id: '실시방법', title: '실시방법', type: 'text', placeholder: '', style: { textAlign: 'left' }  },
        { id: '예산액', title: '예산액(백만원)', type: 'number', placeholder: '' },
        { id: '비고', title: '비고', type: 'text', placeholder: '', style: { textAlign: 'left' }  },
      ]"
        v-model="form.점검계획리스트" />

      <table-custom
        class="mt-8"
        :board="board"
        :is-print="isPrint"
        title="□ 분야별 중점 점검사항"
        thema="label"
        :tableData="[
        { id: '구분', title: '구분', type: 'text', placeholder: '', width: '220px' },
        { id: '점검내용', title: '세부구분', type: 'text', placeholder: '', style: { textAlign: 'left' }  },
        { id: '비고', title: '비고', type: 'text', placeholder: '', width: '220px', style: { textAlign: 'left' }  },
      ]"
        v-model="form.분야별중점점검사항리스트" />

      <div class="mt-4">
        <p v-if="isPrint" class="print-textarea" v-html="form.분야별중점점검사항" />
        <ml-textarea v-else @input="(value) => inputTextArea('분야별중점점검사항', value)" class="w-full"
                     :value="form.분야별중점점검사항.replace(/<br\/>/g, '\n')" rows="10"/>
      </div>
      <p class="mt-4">※ 원료·제조물: 시행령 제9조제2항1호에 따라 안전·보건 관계 법령에 따른 의무 이행은 반기 1회 이상 점검</p>
      <p class="mt-8 sTitle">□ 점검결과 따른 조치계획</p>
      <div class="mt-4">
        <p v-if="isPrint" class="print-textarea" v-html="form.점검결과따른조치계획" />
        <ml-textarea v-else @input="(value) => inputTextArea('점검결과따른조치계획', value)" class="w-full"
                     :value="form.점검결과따른조치계획.replace(/<br\/>/g, '\n')" rows="6"/>
      </div>

      <!-- 2. 유지관리 계획 -->
      <div class="mt-4">
        <h5><i class="dot"></i> 2. 유지관리 계획</h5>
      </div>
      <table class="mt-2">
        <tr>
          <th class="p-4">
            <p style="font-weight: 400; font-size: 14px; text-align: start;">
              ▶ 작성방법<br/>
              - 당해연도 시행 할 주요 보수·보강 계획 작성<br/>
              - 정기점검 및 수시점검 계획에 따른 유지관리계획 작성<br/>
              ※ 아래사항은 세부추진계획 작성을 위한 형식, 대상 법령 등을 기재하였으므로 필요사항을 참고하여 작성조치
            </p>
          </th>
        </tr>
      </table>

      <table-custom
        class="mt-8"
        :board="board"
        :is-print="isPrint"
        thema="label"
        :tableData="[
        { id: '구분', title: '구분', type: 'text', placeholder: '', style: { textAlign: 'left' }  },
        { id: '대상', title: '대상', type: 'text', placeholder: '', style: { textAlign: 'left' }  },
        { id: '점검시기', title: '점검시기', type: 'text', placeholder: '', style: { textAlign: 'left' }  },
        { id: '시행방법', title: '시행방법', type: 'textarea', placeholder: '', style: { textAlign: 'left' }  },
        { id: '예산액', title: '예산액(백만원)', type: 'number', placeholder: '', style: { textAlign: 'left' }  },
        { id: '보강보수내용', title: '보강·보수내용', type: 'text', placeholder: '', style: { textAlign: 'left' }  },
      ]"
        v-model="form.유지관리계획리스트" />

      <!-- 3. 관련법령에 따른 의무사항 이행계획 -->
      <div class="mt-4">
        <h5><i class="dot"></i> 3. 관련법령에 따른 의무사항 이행계획</h5>
        <p class="my-4 sTitle">❍ 관련법령에 따른 의무사항 이행(시행령 제11조 제2항)</p>
      </div>
      <table class="mt-2">
        <tr>
          <th class="p-4">
            <p style="font-weight: 400; font-size: 14px; text-align: start;">
              ▶ 작성방법<br/>
              - 소관 시설물과 관련된 모든 관계법령에 대한 의무사항을 기재<br/>
              ※ 아래사항은 세부추진계획 작성을 위한 형식, 대상 법령 등을 기재하였으므로 필요사항을 참고하여 작성조치<br/>
            </p>
          </th>
        </tr>
      </table>
      <table-custom
        class="mt-8"
        :board="board"
        :is-print="isPrint"
        thema="label"
        :tableData="[
        { id: '관련법령', title: '관련법령', type: 'text', placeholder: '', style: { textAlign: 'left' } },
        { id: '의무사항', title: '의무사항', type: 'text', placeholder: '', style: { textAlign: 'left' }  },
        { id: '이행계획', title: '이행계획', type: 'text', placeholder: '', style: { textAlign: 'left' }  },
        { id: '비고', title: '비고', type: 'text', placeholder: '', style: { textAlign: 'left' }  },
      ]"
        v-model="form.관련법령에따른의무사항이행계획리스트" />
    </div>
    <p class="mt-4">※ 시설별 관리법령에 따른 의무사항 전수조사 및 기재</p>

    <p class="mt-8 sTitle">❍ 안전·보건 관계법령의 기준</p>
    <p class="mt-4">→ 안전·보건 관계 법령은 해당 공중이용시설에 적용되는 것으로서 이용자나 그 밖의 사람의 안전·보건을 확보하는 데 관련되는 법령을 말함</p>
    <table class="mt-4">
      <tr>
        <th class="p-4">
          <p style="font-weight: 500; font-size: 17px; text-align: start;">▶ 구제적으로</p>
          <p style="font-weight: 400; font-size: 14px; text-align: start; margin-top: 10px;">
            ❶ 공중이용시설 또는 공중교통수단의 안전 확보를 목적으로 하는 법률<br/>
            ❷ 대상을 이용하는 국민의 안전을 위해 의무를 부과하는 법률<br/>
            ❸ 공중이용시설 및 공중교통수단을 구성하는 구조체, 시설, 설비, 부품 등의 안전에 대하여 안전점검, 보수·보강 등을 규정하는 법률<br/>
            ❹ 이용자의 안전을 위해 관리자, 종사자가 관련 교육을 이수토록 규정하는 법률 등을 안전·보건 관계법령으로 보고자 함
          </p>
        </th>
      </tr>
    </table>
    <table class="mt-4">
      <tr>
        <th class="p-4">
          <p style="font-weight: 500; font-size: 17px; text-align: start;">▶ 안전·보건 관계법령의 예시</p>
          <p style="font-weight: 400; font-size: 14px; text-align: start; margin-top: 10px;">
            ❶ 도로교량, 터널: 시설물안전법<br/>
            ❷ 건축물: 시설물안전법, 건축물관리법, 초고층재난관리법<br/>
            ※ 초고층재난관리법은 층수가 50층 이상 또는 높이가 200m 이상인 건축물 등에 적용<br/>
            ❸ 하천시설(하구둑, 제방 보): 시설물안전법, 하천법<br/>
            ❹ 상하수도시설: 시설물안전법, 수도법, 하수도법<br/>
            ❺ 옹벽 및 전토사면: 시설물안전법<br/>
            ❻ 국공립어린이집: 영유아법, 실내공기질법, 기타등등
          </p>
        </th>
      </tr>
    </table>

    <p class="mt-8 sTitle">❍ 안전관리자 등 교육이수 계획(시행령 제11조 제2항 3호)</p>
    <table class="mt-2">
      <tr>
        <th class="p-4">
          <p style="font-weight: 400; font-size: 14px; text-align: start;">
            ▶ 작성방법<br/>
            - 소관 시설물과 관련된 모든 교육대상자의 교육이수 계획 수립<br/>
            ※ 아래사항은 세부추진계획 작성을 위한 형식, 대상 법령 등을 기재하였으므로 필요사항을 참고하여 작성조치
          </p>
        </th>
      </tr>
    </table>

    <div class="writeGridContainer mt-4">
      <div>
        <div>(교육대상)</div>
        <p v-if="isPrint" class="print-input" v-html="form.교육대상" />
        <ml-input v-else v-model="form.교육대상" class="w-full" />
      </div>
      <div/><div/>
      <div>
        <div>(이수점검)</div>
        <p v-if="isPrint" class="print-input" v-html="form.이수점검" />
        <ml-input v-else v-model="form.이수점검" class="w-full" />
      </div>
    </div>

    <table-custom
      :board="board"
      :is-print="isPrint"
      thema="label"
      :tableData="[
        { id: '교육대상', title: '교육대상', type: 'text', placeholder: '', style: { textAlign: 'left' }  },
        { id: '교육과정', title: '교육과정', type: 'textarea', placeholder: '', style: { textAlign: 'left' }  },
        { id: '교육시간', title: '교육시간', type: 'textarea', placeholder: '', style: { textAlign: 'left' }  },
        { id: '교육방법', title: '교육방법', type: 'textarea', placeholder: '', style: { textAlign: 'left' }  },
        { id: '비고', title: '비고', type: 'text', placeholder: '', style: { textAlign: 'left' }  },
      ]"
      v-model="form.교육이수계획리스트" />



    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" title="파일첨부" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>

  </div>
  <print v-else :form="form" />
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import DateSelectorRang from "@/components/selector/DateSelectorRang.vue";
import TableCustom from "@/components/TableCustom.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import FieldSelector from "@/components/selector/FieldSelector.vue";
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import {quillEditor} from 'vue-quill-editor'
import NumberInput from "@/components/NumberInput.vue";
import TableOrganogram from "@/components/TableOrganogram.vue";
import Print from "@/views/boards/single-page/1046/Print.vue";

export default {
  components: {
    Print,
    TableOrganogram,
    NumberInput,
    FieldSelector,
    DateSelector,
    PhotoUploadGridModule,
    TableCustom,
    DateSelectorRang,
    FileUploadModule,
    FieldSelectModule,
    quillEditor
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  computed: {
    fieldTypes() {
      return ["com_name", "rank", "writer_name", "date"];
    },
    fieldNames() {
      const fields = this.form.시설명.map((item) => {
        return item.field_name;
      });
      return fields.join(", ");
    },
    안전예산편성액_계() {
      const result = this.form.안전예산현황리스트.reduce((sum, item) => sum + Number(item.편성액), 0);
      return this.comma(result)
    },
    소관부서() {
      if (this.form.시설명 && this.form.시설명.length > 0) {
        const 소관부서 = this.form.시설명.map((item) => {
          const meta = item.meta ? JSON.parse(item.meta) : {};
          return meta.소관부서;
        });
        return [...new Set(소관부서)].join(', ')
      }
      return ""
    }
  },
  data() {
    return {
      allCheck: false,
      years: Array.from({ length: new Date().getFullYear() - 2001 + 1 }, (_, i) => 2001 + i).reverse(),
      allCheckWorkForce: false,

      form: {
        stdInfo: {},
        photoList: [],
        fileList: [],

        시설명: [],
        관리방법: "",
        소관부서: "",
        머리글: "｢중대재해처벌 등에 관한 법률｣ 및 ｢00000에 관한 법률(시설소관법령기재)｣ ○○○시설의 산업안전보건대책을 마련하여 중대 시민재해 예방에 선제적으로 대응하고자 함",
        관련근거: "<p>❍「중대재해처벌법」 제9조 제2항 및 동법 시행령 제10조·제11조</p>" +
          "<p> - 안전계획 수립·이행, 이행점검, 필요조치 시행</p>" +
          "<p>❍「시설물안전법」제6조 및 동법 시행령 제3조, 동법 시행규칙 제3조</p>" +
          "<p> - 시설물의 안전 및 유지관리계획 수립·시행 및 제출</p>" +
          "<p>❍ 그 외 해당 시설물 관련 법령</p>" +
          "<p>※ 관련근거: 원료·제조물(예: 어린이놀이시설)이 공중이용시설(예: 어린이집)에 포함되어 있는 경우 각각 법률 기재(예: 어린이 놀이시설 안전관리법, 영유아보육법)</p>" +
          "<p><br></p>" +
          "<p>&lt; 법령의 주요내용 &gt;</p>" +
          "<p>◆ (적용대상) 공중이용시설(법 제2조제4호 가목 - 연면적 3,000㎡이상 업무시설)</p>" +
          "<p>◆ (안전 및 보건확보 의무) 사업주·경영책임자 등이 실질적으로 관리하는 사업장 에서 이용자 또는 그 밖의 사람의 생명, 신체의 <span style='color: #4839EB'>안전을 보호하고 위험 방지</span></p>" +
          "<p> ※ 안전보건관리체계 구축 및 이행, 재해발생시 재발방지대책 수립 및 이행, 교육실시 확인 등 관리상의 조치</p>" +
          "<p>◆ (처벌규정) 안전․보건 확보 의무 위반으로 중대시민재해가 발생한 경우</p>" +
          "<p><br></p><p>" +
          "<img src=\"https://gnsc.maot.co.kr:8080/storage/app/media/%EC%95%88%EC%A0%84%EA%B3%84%ED%9A%8D%EC%88%98%EB%A6%BD_%EA%B4%80%EB%A0%A8%EA%B7%BC%EA%B1%B0.png\"></p>" +
          "<p><br></p>" +
          "<p>※ <span style='color: #4839EB'>경영책임자 등의 고의·중과실로 중대재해가 발생한 경우</span> 해당 사업주, 법인 또는 기관이 손해 입은 개인에 손해액의 <span style='color: #4839EB'>5배 이내의 징벌적 손해배상 책임</span></p>",

        안전관리대상시설현황: "❍ 00랜드 안전관리 대상시설\n" +
          "    - 주차관리, 문화복지, 생활레저, 녹지환경 등 4개 사업군",
        안전관리대상시설현황리스트: [
          { id: 1, 관리주체: "○○랜드", 구분유형: "생활여가시설", 사용용도: "공영주차장 등", 구조: "다중이용시설(주차장)", 연면적: "000", 비고: "유", }
        ],
        안전사고발생현황: "❍ 다중이용시설 등 복잡 다양한 시설물의 혼재\n" +
          "    - 체육문화회관, ○○증진센터 등 동일 건물내 다양한 목적의 시설이 혼재\n" +
          "❍ 안전사고 발생현황(2022~ 2024년)",
        안전사고발생년도: 2025,
        안전사고발생현황리스트: [
          { 구분: "계", 년도별: [0, 0, 0] },
          { 구분: "사망자수", 년도별: [0, 0, 0] },
          { 구분: "부상자수", 년도별: [0, 0, 0] },
        ],
        안전등급및점검결과: "❍ 2024년 안전등급 및 점검결과",
        안전등급및점검결과리스트: [
          {
            id: 1,
            구분: "1청사",
            시설물분류: "제3종시설물\n(연면적 1,000㎡ 이상의 공공청사)",
            점검결과: "B등급\n(중대결함 없음, 일부 실과 누수발생)",
            조치결과: "-5층 외벽보수(2024.8.22.)",
          },
          {
            id: 2,
            구분: "2청사",
            시설물분류: "제2종시설물\n(연면적 30,000㎡이상의 건축물)",
            점검결과: "A등급\n(전반적인 구조물 상태 양호, 건조수축에 따른 미세균열)",
            조치결과: "-지하2층 화장실 균열보수\n(2024.8.28.)",
          }
        ],
        is총예산입력: false,
        안전예산현황리스트: [
          { title: "① 안전점검비용", content: "공중이용시설에 대한 정기안전점검, 정밀안전진단, 긴급안전점검 등의 비용", 편성액: 0, 비고: "" },
          { title: "② 보수·보강비용", content: "시설의 안전과 정비·점검을 위한 장비 확보비용\n" +
              "시설물의 보수·보강 등의 비용", 편성액: 0, 비고: "" },
          { title: "③ 안전조치비용", content: "공중이용시설에 대한 긴급안전조치, 이용제한 등 안전조치 등 비용", 편성액: 0, 비고: "" },
          { title: "④ 인건비", content: "안전점검 또는 보수·보강 업무 수행인력 인건비", 편성액: 0, 비고: "" },
          { title: "⑤ 기타 비용", content: "그 외 안전확보에 소요되는 비용", 편성액: 0, 비고: "" },
        ],
        안전예산현황리스트_비고: "",
        안전예산현황_총예산: { 편성액: 0, 비고: "" },

        인력현황리스트: [
          {
            id: 1, 구분: "안전계획이행", 해당업무: "안전계획이행\n- 안전계획 수립\n- 안전 관련 예산 편성·집행\n- 이행점검, 개선조치 ",
            계: 0, 공무원: 0, 공무직: 0, 기간제: 0, 보건관리자: 0, 기타: 0, 비고: "", isCheck: false,
          },
          {
            id: 2, 구분: "안전계획이행", 해당업무: "안전점검, 보수보강,\n*안전조치 업무",
            계: 0, 공무원: 0, 공무직: 0, 기간제: 0, 보건관리자: 0, 기타: 0, 비고: "", isCheck: false,
          }
        ],
        organogram1: {
          "organizations": [
            {"lv": 1, "name": "안전보건관리책임자 (사천시청장)", "component": "label"},
            {"lv": 2, "name": "관리부서장", "component": "edit-input"},
            {"lv": 3, "name": "시설담당자", "component": "edit-input"},
          ]
        },
        organogram2: {
          "organizations": [
            {"lv": 1, "name": "안전보건관리책임자 (사천시청장)", "component": "label"},
            {"lv": 2, "name": "관리부서장", "component": "edit-input"},
            {"lv": 3, "name": "시설담당자", "component": "edit-input"},
          ]
        },

        근거규정: "❍ 「재난 및 안전관리 기본법」제00조\n" +
          "❍ 「시설물 안전법」제00조의 2\n" +
          "❍ 그 외 해당 시설물 점검 관련 법령",
        점검계획리스트:[
          {
            "id": 1, "구분": "시설물안전점검", "세부구분": "정기점검", "점검주기": "연3",
            "내용": "-(내용)건축물 구조, 균열 육안점검\n-(시기)2025. 4월, 8월, 12월",
            "실시방법": "자체", "비고": "시설물안전법 제6조", "예산액": 0
          }
        ],
        분야별중점점검사항리스트: [
          { id: 1, 구분: "건축물 점검", 점검내용: "안전관리실태, 구조 안전성, 건축마감 등" },
          { id: 2, 구분: "소방 점검", 점검내용: "-" },
          { id: 3, 구분: "전기 점검", 점검내용: "-" },
          { id: 4, 구분: "가스 점검", 점검내용: "-" },
          { id: 5, 구분: "승강기 점검", 점검내용: "-" },
          { id: 6, 구분: "기타 점검", 점검내용: "-" },
        ],
        분야별중점점검사항: "○ (구조물) 정기점검·수시점검 등을 통해 유해·위험요인 확인 점검, 시민, 근로자 등으로부터 유해·위험요인 시설물 신고 접수\n" +
          "  · 도로, 터널 등 외관형태를 관찰하여 균열, 파손, 누수여부, 철근부식 등\n" +
          "   결함 여부 파악\n" +
          "  · 시설물 순찰 및 이용자로 부터의 신고 접수 파악한 유해·위험 요인\n" +
          "○ (건축물) 건축, 소방, 승강기, 전기, 위험물 분야 등 개별법에 따른 안전점검 실시\n" +
          "  · 건축분야: 안전관리실태, 벽체·슬래브 등 구조체 균열 여부, 주요 구조부재 안전성, 누수·벽화·철근 노출 및 부식, 건축마감재 접합부 이격 및 변형 여부 등\n" +
          "  · 소방분야: 소화설비, 방화구역, 경보설비, 피난구조설, 소화용수설비 등\n" +
          "  · 승강기분야: 전동기 비상통화장치, 승강자 과부하 감지 장치, 비상정지 스위치, 비상조명 등\n" +
          "  · 전기분야: 전기안전관리, 인입선, 누전·배전용 차단기 배·분전반, 배선상태, 전기 기계기구 및 접지 상태 비상발전설비, 전기실, EPS실, 축전지실\n" +
          "  · 위험물분야: 탱크본체누설여부, 통기관 상태, 누설검지관 변형, 주입구 변형 및 손상, 배관의 누유 및 밸브 상태",
        점검결과따른조치계획: "  ❍ (결과 보고) 긴급조치 결과 및 정기점검 결과 반드시 안전보건관리 총괄책임자(시장) 보고\n" +
          "  ❍ (현장 조치) 현장에서 즉시 시정 가능한 사항은 관리주체가 즉시 시정하도록 조치 \n" +
          "  ❍ (보수·보강) 점검결과 중대한 결함이나 위험요인 발견 시 재난예방을 위해 긴급보수·보강, 사용제한 등 긴급조치 실시 \n" +
          "  ❍ (정밀안전진단) 시설물의 재해 및 재난 예방과 안전성 확보 등을 위해 필요한 경우 안전진단전문기관에서 정밀안전진단실시 \n" +
          "    ※ 정밀안전진단 대상 발생 시, 안전보건관리총괄책임자(시장)에게 보고 \n" +
          "  ❍ (점검결과 입력) 안전점검 결과에 따른 후속조치와 사후관리를 위해「FMS시스템」 및 관련법령에 따른 타 시스템이 있을 경우 점검결과입력하고, 관련 시스템이 없을 경우 수기대장으로 관리",
        유지관리계획리스트: [
          { id: 1, 구분: "주요 보수보강 계획", 대상: "건축물", 점검시기: "1월", 시행방법: "자체", 예산액: 50, 보수보강내용: "노후계단 교체", }
        ],
        관련법령에따른의무사항이행계획리스트: [
          { id: 1, 관련법령: "(예시)건축물관리법", 의무사항: "건축물 유지관리 정기점검", 이행계획: "매년 3년단위", 비고: "제12조,제13조", },
          { id: 2, 관련법령: "(예시)시설물안전법", 의무사항: "정밀안전점검, 정밀안전진단", 이행계획: "반기1회 이상 4년 1회 이상", 비고: "제11조, 제12조", },
        ],
        교육대상: "안전관리자 등",
        이수점검: "연1회 이상 점검",
        교육이수계획리스트: [
          {
            id: 1, 교육대상: "소방안전관리자", 교육과정: "신규(선임 6개월 이내)\n보수(2년 주기)",
            교육시간: "6시간 이상\n6시간 이상", 교육방법: "온라인", 비고: "한국소방안전원"
          },
          {
            id: 2, 교육대상: "안전관리자", 교육과정: "신규(선임 6개월 이내)\n보수(3년 주기)",
            교육시간: "21시간\n21시간", 교육방법: "-집체(12시간)+온라인(9시간)\n-집체(8시간)+온라인(13시간)",  비고: "전기기술교육원"
          },
          {
            id: 3, 교육대상: "가스안전관리자", 교육과정: "신규(선임 6개월 이내)\n보수(3년 주기)",
            교육시간: "7시간 이상\n3시간 이상", 교육방법: "집체",  비고: "한국가스안전공사"
          },
          {
            id: 4, 교육대상: "위험물안전관리자", 교육과정: "신규(선임 6개월 이내)\n보수(2년 주기)",
            교육시간: "8시간", 교육방법: "집체(4시간)+온라인(4시간)",  비고: "한국소방안전원"
          },
        ],
      },

    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    // textarea에서 줄바꿈을 <br/>로 변환
    inputTextArea(name, value) {
      this.form[name] = value.replace(/\n/g, "<br/>");
    },
    comma (str) {
      return `${str}`.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    input_인력현황(index) {
      this.form.인력현황리스트[index].계 = this.form.인력현황리스트[index].공무직 +
        this.form.인력현황리스트[index].공무원 + this.form.인력현황리스트[index].기간제 +
        this.form.인력현황리스트[index].보건관리자 + this.form.인력현황리스트[index].기타
    },
    handleAddRowWorkForce () {
      this.form.인력현황리스트.push({
        id: Date.now() + Math.floor(Math.random() * 1000),
        구분: "",
        해당업무: "",
        계: 0,
        공무원: 0,
        공무직: 0,
        기간제: 0,
        보건관리자: 0,
        기타: 0,
        비고: "",
        isCheck: false,
      });
    },
    handleRemoveRowWorkForce () {
      this.form.인력현황리스트 = this.form.인력현황리스트.filter(item => !item.isCheck);
    },
    handleSelectAllWorkForce (value) {
      this.allCheckWorkForce = !this.allCheckWorkForce;
      this.form.인력현황리스트.forEach(item => {
        item.isCheck = this.allCheckWorkForce;
      });
    },
  },

};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th, td {
    border: solid #cdcdcd 1px;
    text-align: center;
    font-size: 14px;
  }

  th {
    background: #f9f9f9;
    padding: 12px 6px;
  }

  td {
    padding: 6px;
  }
}

.eTitle {
  font-family: Noto Sans KR;
  font-weight: 700;
  font-size: 17px;
  line-height: 100%;
  height: 22px;
  vertical-align: middle;
  border-left: 4px solid #000;
  padding: 0 6px;
}

.sTitle {
  font-size: 16px;
}
</style>
